import {
  AppBanner,
  CookiesProvider,
  FooterSimplified,
  GenericErrorContent,
  HeaderContainer,
  ThemeProvider,
  ToastContainer,
  UserInfoProvider
} from '@spotahome/ui-library';
import { lazy, Suspense } from 'react';
import NoSSR from 'react-no-ssr';

const LoginModal = lazy(() =>
  import('@spotahome/ui-library/src/tenant/components/LoginSignupModalWrapper')
);

const NotFound = ({ initialCookie, deviceType, deviceViewType, source }) => {
  return (
    <CookiesProvider initialCookie={initialCookie}>
      <ThemeProvider flags={{ newButtons: true }}>
        <UserInfoProvider>
          <ToastContainer />
          <AppBanner source={source} deviceType={deviceType} />
          <HeaderContainer deviceType={deviceType} />
          <GenericErrorContent
            title="error_page.not_found.h1"
            subtitle="error_page.not_found.content"
            errorCode={404}
          />
          <FooterSimplified />
          <NoSSR>
            <Suspense fallback={null}>
              <LoginModal deviceViewType={deviceViewType} />
            </Suspense>
          </NoSSR>
        </UserInfoProvider>
      </ThemeProvider>
    </CookiesProvider>
  );
};

export default NotFound;
